import { currentWebsiteName } from '@/utils/currentWebsite';

export default {
  computed: {
    activeWebsiteName() {
      return currentWebsiteName.value;
    },
  },
};
